export default __webpack_public_path__ + "static/media/testimonial-lazy-mike.c2767e96.jpg";